(function() {

  $(window).on('popstate', onChangeUrl);

  $( '[modal]' ).on( 'click', onClickModal );
  $( '.tela .container-modal .close' ).on( 'click', onClickCloseModal );

  function onClickModal() {
    var name = $( this ).attr( 'modal' );
    history.pushState({}, '', name);
    openModal(name);
  }

  function onClickCloseModal() {
    history.back();
  }

  function openModal(name) {
    $( '#' + name + '.tela' ).addClass( 'show' );
    $(window).scrollTop(0);
  }

  function closeModal() {
    $( '.tela' ).removeClass( 'show' );
  }

  function onChangeUrl(url) {
    var modal = '';
    $('.tela').each(function(index, div) {
      var id = $(div).attr('id');
      if (location.href.indexOf(id) > -1) {
        modal = id;
      }
    });
    if (modal) {
      openModal(modal);
    } else {
      closeModal();
    }
  }

})();
